export const resolveLocationByBarcode = async (barcode: string): Promise<number | null> => {
  try {
    const resp = await fetch('/api/inventory/location/?q=' + encodeURIComponent(barcode), {
      credentials: 'same-origin',
    })
    if (!resp.ok) return null
    const data = await resp.json()
    const locations: { id: number; barcode: string }[] = data.locations || []
    const match = locations.find((loc) => loc.barcode === barcode)
    return match ? match.id : null
  } catch {
    return null
  }
}
